// Import model
import { ReferenceField } from '../models/ReferenceField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ReferenceField - handles JSON serialization and deserialization with type validation
 */
export class ReferenceFieldSerializer {
  /**
   * Deserializes a JSON string into a ReferenceField instance
   */
  static deserialize(json: string): ReferenceField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ReferenceField instance
   */
  static fromObject(obj: any): ReferenceField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ReferenceField');
    }


    const instance: ReferenceField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      f3B82D4C: obj['_f3b82d4c'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ReferenceField instances
   */
  static deserializeArray(json: string): ReferenceField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ReferenceField instance to a JSON string
   */
  static serialize(instance: ReferenceField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ReferenceField instance to a plain object
   */
  static toObject(instance: ReferenceField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_f3b82d4c': instance.f3B82D4C,
    };
  }

  /**
   * Serializes an array of ReferenceField instances to a JSON string
   */
  static serializeArray(instances: ReferenceField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
